module.exports = __webpack_public_path__ + "static/template_options_form_letter-ff8e52f6dfb6eac757db0babbe269c4c.png";